/**
 * Harsh Infowise — HIW custom component core
 * Scroll reveal, stat counters, testimonial carousel, FAQ height helper.
 */
(function () {
  if (window.__HIW_CORE_INIT__) return;
  window.__HIW_CORE_INIT__ = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    const nodes = document.querySelectorAll('[data-hiw-reveal]:not(.hiw-is-visible)');
    if (!nodes.length) return;

    if (prefersReducedMotion) {
      nodes.forEach((el) => el.classList.add('hiw-is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hiw-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach((el) => observer.observe(el));
  }

  function parseStatValue(raw) {
    const str = String(raw || '').trim();
    const match = str.match(/^([\d.,]+)\s*(.*)$/);
    if (!match) return { num: null, suffix: str, prefix: '' };
    const num = parseFloat(match[1].replace(/,/g, ''));
    const rest = match[2] || '';
    if (str.startsWith('+')) return { num, suffix: rest, prefix: '+' };
    return { num, suffix: rest, prefix: '' };
  }

  function animateCounter(el) {
    const target = el.dataset.hiwCount;
    if (!target || el.dataset.hiwCounted === 'true') return;
    const { num, suffix, prefix } = parseStatValue(target);
    if (num === null || Number.isNaN(num)) return;

    el.dataset.hiwCounted = 'true';
    const duration = prefersReducedMotion ? 0 : 1400;
    const start = performance.now();
    const decimals = String(target).includes('.') ? 1 : 0;

    function tick(now) {
      const t = duration === 0 ? 1 : Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = num * eased;
      el.textContent =
        prefix +
        (decimals ? current.toFixed(decimals) : Math.round(current).toString()) +
        (suffix ? (suffix.startsWith(' ') ? suffix : ' ' + suffix) : '');
      if (t < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initCounters() {
    document.querySelectorAll('[data-hiw-count]').forEach((el) => {
      if (prefersReducedMotion) {
        el.textContent = el.dataset.hiwCount;
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(el);
    });
  }

  function initTestimonials(root) {
    const slides = root.querySelectorAll('[data-hiw-slide]');
    const dots = root.querySelectorAll('[data-hiw-dot]');
    if (slides.length < 2) return;

    let index = 0;
    let timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => {
        s.classList.toggle('hiw-testimonials__slide--active', idx === index);
        s.setAttribute('aria-hidden', idx === index ? 'false' : 'true');
      });
      dots.forEach((d, idx) => {
        d.classList.toggle('hiw-testimonials__dot--active', idx === index);
        d.setAttribute('aria-selected', idx === index ? 'true' : 'false');
      });
    }

    function next() {
      show(index + 1);
    }

    function startAutoplay() {
      if (prefersReducedMotion || root.dataset.hiwAutoplay === 'false') return;
      clearInterval(timer);
      timer = setInterval(next, Number(root.dataset.hiwInterval) || 6000);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        startAutoplay();
      });
    });

    root.querySelector('[data-hiw-prev]')?.addEventListener('click', () => {
      show(index - 1);
      startAutoplay();
    });
    root.querySelector('[data-hiw-next]')?.addEventListener('click', () => {
      show(index + 1);
      startAutoplay();
    });

    show(0);
    startAutoplay();
  }

  function initFaq(root) {
    root.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    initReveal();
    initCounters();
    document.querySelectorAll('[data-hiw-testimonials]').forEach(initTestimonials);
    document.querySelectorAll('[data-hiw-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
